import React from "react";
import { displayAlert } from "utils/AlertUtil";
import * as s from "../../../pages/alert/AlertStyled";
import * as mediaQuery from "components/MediaQuery";

export default function AlertDisplay({
  alertTypeString,
  alertType,
  cameraName,
  channel,
}: {
  alertTypeString?: string;
  alertType: string;
  cameraName?: string;
  channel?: number;
}) {
  const { type, detail } = displayAlert({
    alertTypeString,
    alertType,
    cameraName,
    channel,
  });
  const isDesktop = mediaQuery.useIsDesktop();
  return (
    <s.DisplayAlert>
      <span>{type}</span>
      {isDesktop && <span>{detail}</span>}
    </s.DisplayAlert>
  );
}
